// Detail screen opening error
export const ERROR_CODE_A012 = 'A012';

// Deeplink opening error
export const ERROR_CODE_A013 = 'A013';

// Detail screen opening OPF 5** error
export const ERROR_CODE_A014 = 'A014';

// Channel not subscribed error
export const ERROR_CODE_P008 = 'P008';

// Blackout error
export const ERROR_CODE_A201 = 'A201';
